import React from "react";
import timerIcon from "../../assets/images/settings/timer_pending.svg";
import checkIcon from "../../assets/images/settings/check_active.svg";

export default function KybStatusBadge({ status, className = "" }) {
  if (status === "pending") {
    return (
      <span
        className={`inline-flex items-center gap-[5px] text-[10px] font-bold uppercase tracking-[0.5px] leading-[14px] text-[#fb8137] bg-[#fff2eb] px-2 py-0.5 rounded-full ${className}`}
      >
        <img src={timerIcon} alt="" className="w-3 h-3" />
        Pending
      </span>
    );
  }

  if (status === "approved") {
    return (
      <span
        className={`inline-flex items-center gap-[5px] text-[10px] font-bold uppercase tracking-[0.5px] leading-[14px] text-[#0e7563] bg-[#e8f9f6] px-2 py-0.5 rounded-full ${className}`}
      >
        <img src={checkIcon} alt="" className="w-3 h-3" />
        Active
      </span>
    );
  }

  return null;
}
